import { Field, ErrorMessage, useFormikContext } from 'formik';
import {
  FieldEntityProps,
  FieldClassNameInterface,
  SelectOptions,
  ObjStrKeyStrVal,
} from '../types';
import { getSelectOptions } from '../utils';

interface AccessibleSelectFieldProps {
  field: FieldEntityProps;
  placeholder: string;
  selectOptions: SelectOptions[];
  selectFieldClassNames: FieldClassNameInterface;
  isTouchedAndError: boolean;
  isRequired: boolean;
  showErrorMessages?: boolean;
}

const AccessibleSelectField = ({
  field,
  placeholder,
  selectOptions,
  selectFieldClassNames,
  isTouchedAndError,
  isRequired,
  showErrorMessages = false,
}: AccessibleSelectFieldProps) => {
  const { setFieldValue } = useFormikContext<ObjStrKeyStrVal>();
  const options = getSelectOptions(field.parameterName, selectOptions);
  const errorClass = isTouchedAndError ? 'errorBorder' : '';
  const errorId = `${field.parameterName}-error`;

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setFieldValue(field.parameterName, e.target.value);
    if (field.parameterName === 'program_type') {
      setFieldValue('program_specialization', '');
    }
  };

  return (
    <>
      <Field
        as="select"
        name={field.parameterName}
        id={field.parameterName}
        className={`${selectFieldClassNames.mainField} ${errorClass}`}
        onChange={handleChange}
        aria-label={field.name}
        aria-required={isRequired}
        aria-invalid={isTouchedAndError}
        aria-describedby={
          showErrorMessages && isTouchedAndError ? errorId : undefined
        }
      >
        <option value="">{placeholder}</option>
        {options?.map((opt, key) => (
          <option key={key} value={opt}>
            {opt}
          </option>
        ))}
      </Field>
      {showErrorMessages && (
        <ErrorMessage name={field.parameterName}>
          {(msg) => (
            <div
              id={errorId}
              role="alert"
              className={isTouchedAndError ? 'errorMessage' : 'errorHide'}
            >
              {msg}
            </div>
          )}
        </ErrorMessage>
      )}
    </>
  );
};

export default AccessibleSelectField;
